import logo from './logo.svg';
import './App.css';
import AllRoutes from './routes';
import Canonical from './components/Canonical';

function App() {
  return (
    <>
      <AllRoutes />
      <Canonical />
    </>
  );
}

export default App;
